import React from 'react';
import headerUnderline from '../assets/figma/header-underline.svg';
import educationDivider from '../assets/figma/education-divider.svg';

const About = () => (
  <section className="about-section" id="about-section">
    <div className="about-wrapper">
      <div className="about-left">
        <header className="about-header">
          <div className="about-kicker">
            <span className="about-kicker-dot" />
            <span>About Me</span>
          </div>
          <h2>Driven by data and code</h2>
          <img className="about-underline" src={headerUnderline} alt="" aria-hidden="true" />
        </header>
        <p className="about-lead">
          I&apos;m an engineer with a strong foundation in software engineering,
           AI/ML, Data and Cloud. Recently completed my MCA after completing my BCA with a minor in
          Financial Modeling .
        </p>
        <p className="about-copy">
          I recently completed an engineering internship at PayNearby where I
          built automated testing infrastructure for fintech applications. I
          leverage my analytical background to solve real-world problems.
        </p>
      </div>

      <aside className="education-card">
        <h3>Education</h3>
        <div className="education-list">
          <div className="education-item">
            <div className="education-meta">
              <strong>Masters in Computer Applications</strong>
              <span>2024-2026</span>
            </div>
            <p>VES Institute of Technology, Mumbai</p>
          </div>

          <img className="education-divider" src={educationDivider} alt="" aria-hidden="true" />

          <div className="education-item">
            <div className="education-meta">
              <strong>Bachelors in Computer Applications</strong>
              <span>2021-2024</span>
            </div>
            <small>Minors in Financial Modeling</small>
            <p>S K Somaiya College</p>
          </div>
        </div>
      </aside>
    </div>
  </section>
);

export default About;
